export enum QuestionCodeEnum {
  EXPERIENCE_THUMBS = 'EXPERIENCE_THUMBS',
  EXPERIENCE_EMOJIS = 'EXPERIENCE_EMOJIS',
  AI_AGENT_FEEDBACK = 'AI_AGENT_FEEDBACK',
  HELPFUL_THUMBS = 'HELPFUL_THUMBS',
  HELPFUL_WHY = 'HELPFUL_WHY',
}
